import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * Nordnet card forfait atom. Used in packages molecule.
 *
 * extraClass - custom class if needed.
 * speed - The speed.
 * pack - The type of Pack.
 * price - The price.
 */
@customElement('nn-card-forfait')
export class CardForfait extends LitElement {
  static styles = css`
    .package {
      align-items: center;
      box-sizing: border-box;
      background: var(--nn-package_background, #fff);
      border: 1px solid var(--nn-package_border-color, #cac8c8);
      box-shadow: var(--nn-package_box-shadow, 0 8px 30px rgba(0, 0, 0, 0.08));
      border-radius: var(--nn-package_border-radius, 32px);
      cursor: pointer;
      display: flex;
      flex-direction: column;
      font-family: 'font-medium';
      gap: var(--nn-package_gap, 12px);
      height: var(--nn-package_height, 164px);
      justify-content: center;
      max-width: 100%;
      text-align: center;
      transition: var(--nn-package_transition, 0.3s);
      user-select: none;
      width: var(--nn-package_width, 200px);
    }

    .package:hover {
      border: 1px solid var(--nn-package__hover_border-color, #999);
    }

    .package:active {
      box-shadow: var(
        --nn-package__active_box-shadow,
        0 0 5px rgba(0, 0, 0, 0.08)
      );
    }

    .speed {
      display: block;
      font-size: var(--nn-package_speed_font-size, 30px);
      line-height: calc(3px + 2ex);
    }

    .pack {
      border: 1px solid var(--nn-package_pack_border-color, #000);
      border-radius: var(--nn-package_pack_border-radius, 30px);
      display: block;
      font-size: var(--nn-package_pack_font-size, 16px);
      line-height: calc(3px + 2ex);
      padding: var(--nn-package_pack_padding, 4px 16px);
    }

    .price {
      display: block;
      font-size: var(--nn-package_price_font-size, 18px);
      line-height: calc(3px + 2ex);
    }
  `;

  @property({ type: String }) extraClass = '';

  @property({ type: String }) speed = '';

  @property({ type: String }) pack = '';

  @property({ type: String }) price = '';

  render() {
    return html`
      <button
        class="package ${this.extraClass}"
        @click="${this._dispatchClick}"
      >
        <span class="speed">${this.speed}</span>
        <span class="pack">${this.pack}</span>
        <span class="price">${this.price}</span>
      </button>
    `;
  }

  _dispatchClick(e: Event) {
    e.preventDefault();
    const event = new CustomEvent('onClick');
    this.dispatchEvent(event);
  }
}
